// extracted by mini-css-extract-plugin
export default {"cls1":"urKgKGffeKWw18JRIaMl","cls2":"_5Wk8_pH5RXq8OgFTrHm urKgKGffeKWw18JRIaMl"};